module.exports = __webpack_public_path__ + "img/flowPath-item2-off.c6488fe8.png";